<template>
    <!-- 社招招聘 -->
    <div class="mobile-container">
        <div class="social-body">
            <div class="social-form">
                <el-form :model="form" ref="form" size="small" :rules="rules" label-position="top" class="filter-form">
                    <el-form-item prop="UserName" label="岗位类别：">
                        <el-select v-model="deliveryID" placeholder="请选择岗位类别" filterable
                                   class="w100"
                                   size="small" @change="changePosition">
                            <el-option v-for="dict in posttitleNav" :key="dict.id"
                                       :label="`${dict.posttitle} ${dict.posttitle == '护理岗位' ? '' : dict.posttitle == '科研岗位' ? '' : dict.posttitle == '党政管理岗位' ? '' : `（${dict.positionname}）`}`"
                                       :value="dict.posttitle"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="UserName" label="科室/部门：">
                        <el-select v-model="positionID" placeholder="请选择科室/部门" filterable class="w100"
                                   size="small" @change="changePositionNav">
                            <el-option v-for="(item,i) in getDepartNav" :key="item.id"
                                       :label="item.departname"
                                       :value="item.departname"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="UserName" label="学历：">
                        <el-select v-model="mingeID" placeholder="学历" filterable class="w100"
                                   size="small">
                            <el-option v-for="(item,i) in pullByDepartNav" :key="item.id"
                                       :label="item.educationname"
                                       :value="item.id"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="UserName" label="姓名：">
                        <el-input v-model="form.UserName" placeholder="请输入姓名" clearable/>
                    </el-form-item>
                    <el-form-item prop="Sex" label="性别：">
                        <el-select v-model="form.Sex" placeholder="请选择性别" clearable class="w100">
                            <el-option label="男" :value="0"/>
                            <el-option label="女" :value="1"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="出生日期：" prop="BirthDate">
                        <el-date-picker v-model="form.BirthDate" value-format="yyyy-MM-dd" type="date"
                                        placeholder="请选择出生年月日"
                                        class="w100"/>
                    </el-form-item>
                    <el-form-item label="民族：" prop="Nation">
                        <el-input v-model="form.Nation" placeholder="请输入民族" clearable/>
                    </el-form-item>
                    <el-form-item label="身高：" prop="Height">
                        <el-input v-model="form.Height" placeholder="请输入身高（单位cm）" clearable/>
                    </el-form-item>
                    <el-form-item label="身份证号：" prop="IDCardNumber">
                        <el-input v-model="form.IDCardNumber" placeholder="请输入身份证号" :maxlength="18" clearable/>
                    </el-form-item>
                    <el-form-item label="政治面貌：" prop="PoliticsStatus">
                        <el-select v-model="form.PoliticsStatus" placeholder="请选择政治面貌"
                                   filterable clearable
                                   class="w100">
                            <el-option v-for="dict in politicsNav" :key="dict.dict_code"
                                       :label="dict.dict_label" :value="dict.dict_label"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="婚姻状况：" prop="MaritalStatus">
                        <el-select v-model="form.MaritalStatus" placeholder="请选择婚姻状况"
                                   filterable clearable
                                   class="w100">
                            <el-option label="未婚" :value="0"/>
                            <el-option label="已婚" :value="1"/>
                            <el-option label="丧偶" :value="2"/>
                            <el-option label="离婚" :value="3"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系方式：" prop="ContactWay">
                        <el-input v-model="form.ContactWay" placeholder="请输入联系方式" clearable/>
                    </el-form-item>
                    <el-form-item label="电子邮箱：" prop="Email">
                        <el-input v-model="form.Email" placeholder="请输入电子邮箱" clearable/>
                    </el-form-item>
                    <el-form-item label="籍贯：" prop="NativePlace">
                        <el-input v-model="form.NativePlace" placeholder="请输入籍贯（例：广东省湛江市霞山区）" clearable/>
                    </el-form-item>
                    <el-form-item label="现户籍地：" prop="PlaceDomicile">
                        <el-input v-model="form.PlaceDomicile"
                                  placeholder="请输入现户籍地（例：广东省湛江市霞山区）" clearable/>
                    </el-form-item>
                    <el-form-item label="通讯地址：" prop="MailingAddress">
                        <el-input v-model="form.MailingAddress"
                                  placeholder="请输入详细通讯地址（精确到街道、单位或小区）" clearable/>
                    </el-form-item>
                    <el-form-item label="邮政编码：">
                        <el-input v-model="form.ZipCode" placeholder="请输入邮政编码" clearable/>
                    </el-form-item>
                    <el-form-item label="最高学历：" prop="HighestEducationID">
                        <el-select v-model="form.HighestEducationID" placeholder="请选择最高学历"
                                   filterable clearable
                                   class="w100" @change="changeHighest">
                            <el-option v-for="dict in HighestNav" :key="dict.dict_code"
                                       :label="dict.dict_label" :value="dict.dict_code"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学位：" prop="DegreeID">
                        <el-select v-model="form.DegreeID" placeholder="请选择学位" filterable
                                   clearable class="w100" @change="changeDegree">
                            <el-option v-for="dict in degreeNav" :key="dict.dict_code"
                                       :label="dict.dict_label" :value="dict.dict_code"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="毕业学校：" prop="GraduateSchool">
                        <el-input v-model="form.GraduateSchool" placeholder="请输入毕业学校"
                                  clearable/>
                    </el-form-item>
                    <el-form-item label="毕业时间：" prop="GraduationDate">
                        <el-date-picker v-model="form.GraduationDate" type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="请选择毕业时间"
                                        class="w100">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="学习形式：" prop="LearningStyleID">
                        <el-select v-model="form.LearningStyleID" placeholder="请选择学习形式"
                                   filterable clearable
                                   class="w100" @change="changeLearning">
                            <el-option v-for="dict in learningNav" :key="dict.dict_code"
                                       :label="dict.dict_label" :value="dict.dict_code"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="专业：" prop="Major">
                        <el-input v-model="form.Major" placeholder="请输入所学专业" clearable/>
                    </el-form-item>
                    <el-form-item label="英语水平等级：" prop="EnglishLevelID">
                        <el-select v-model="form.EnglishLevelID" placeholder="请选择英语水平等级"
                                   filterable clearable
                                   class="w100" @change="changeEnglish">
                            <el-option v-for="dict in englishNav" :key="dict.dict_code"
                                       :label="dict.dict_label" :value="dict.dict_code"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="计算机水平等级：" prop="ComputerLevel">
                        <el-input v-model="form.ComputerLevel" placeholder="请输入计算机水平等级"
                                  clearable/>
                    </el-form-item>
                    <el-form-item label="参加工作时间：">
                        <el-date-picker v-model="form.worktime" type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="只填写正式工作时间，由单位缴纳社保的工作经历"
                                        class="w100">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="工作单位：">
                        <el-input v-model="form.LastCompany"
                                  placeholder="只填写正式工作经历，由单位缴纳社保的工作经历"
                                  clearable/>
                    </el-form-item>
                    <el-form-item label="单位性质：">
                        <el-select v-model="form.NatureUnitID" placeholder="请选择单位性质"
                                   filterable clearable
                                   class="w100"
                                   @change="changeNatureUnit">
                            <el-option v-for="dict in NatureUnitNav" :key="dict.dict_code"
                                       :label="dict.dict_label" :value="dict.dict_code"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="最高专业技术资格：" prop="ProfessionalSkill">
                        <el-input v-model="form.ProfessionalSkill"
                                  placeholder="请输入最高专业技术资格（若无，请填无）" clearable/>
                    </el-form-item>
                    <el-form-item label="职称：">
                        <el-input v-model="form.Post" placeholder="请输入职称" clearable/>
                    </el-form-item>
                    <el-form-item label="执业资格：">
                        <el-input v-model="form.PracticeCertificate" placeholder="请输入执业资格"
                                  clearable/>
                    </el-form-item>
                    <el-form-item label="学习经历" required>
                        <div class="iconLearning">
                            <div class="learningText">添加学习经历(请从中学开始填写）</div>
                            <!-- 填写学习经历 -->
                            <el-popover placement="bottom-start" width="350" trigger="click" v-model="educationShow">
                                <el-form :model="studyForm" size="small" label-position="top" class="filter-form">
                                    <el-form-item label="学习日期">
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <el-date-picker v-model="studyForm.StudyStartDate" type="date"
                                                                value-format="yyyy-MM-dd"
                                                                placeholder="请选择开始时间" class="w100"/>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-date-picker v-model="studyForm.StudyEndDate" type="date"
                                                                value-format="yyyy-MM-dd"
                                                                placeholder="请选择结束时间" class="w100"/>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                    <el-form-item label="毕业院校">
                                        <el-input v-model="studyForm.GraduationSchool" placeholder="请输入毕业院校"/>
                                    </el-form-item>
                                    <el-form-item label="学历">
                                        <el-select v-model="studyForm.EducationID" placeholder="请选择学历" filterable
                                                   class="w100"
                                                   @change="changeEducation">
                                            <el-option v-for="dict in EducationNav" :key="dict.dict_code"
                                                       :label="dict.dict_label" :value="`${dict.dict_code}`"/>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="学习形式">
                                        <el-select v-model="studyForm.LearningStyleID" placeholder="请选择学习形式" filterable
                                                   class="w100"
                                                   @change="changeLearning">
                                            <el-option v-for="dict in learningNav" :key="dict.dict_code"
                                                       :label="dict.dict_label" :value="dict.dict_code"/>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="学制">
                                        <el-input v-model="studyForm.EducationalSystem" placeholder="请输入学制"
                                                  size="small"/>
                                    </el-form-item>
                                    <el-form-item label="所学专业">
                                        <el-input v-model="studyForm.Major" placeholder="请输入所学专业" clearable/>
                                    </el-form-item>
                                </el-form>
                                <div class="text-right mt18">
                                    <el-button size="mini" type="primary" plain @click="handleClose" class="mr8">
                                        取 消
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="submitForm">
                                        保 存
                                    </el-button>
                                </div>
                                <el-button type="text" slot="reference">
                                    <i class="el-icon-circle-plus-outline iconAdd"/>
                                </el-button>
                            </el-popover>
                        </div>
                        <div class="timeBox" v-if="StudyList.length">
                            <el-timeline>
                                <el-timeline-item placement="top" v-for="(item,i) in range" :key="i" color="#409EFF">
                                    <div class="iconDel" @click="studyDel(i)">
                                        <i class="el-icon-delete"></i>
                                    </div>
                                    <div class="timelineItem"><span>学习时间：</span>{{ item.StudyStartDate }} 至 {{
                                        item.StudyEndDate }}
                                    </div>
                                    <div class="timelineItem"><span>学历：</span>{{ item.EducationStyle }}</div>
                                    <div class="timelineItem"><span>毕业院校：</span>{{ item.GraduationSchool }}</div>
                                    <div class="timelineItem"><span>学制：</span>{{ item.EducationalSystem }}</div>
                                    <div class="timelineItem"><span>所学专业：</span>{{ item.Major }}</div>
                                    <div class="timelineItem"><span>学习形式：</span>{{ item.LearningStyle }}</div>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </el-form-item>
                    <el-form-item label="工作经历">
                        <div class="iconLearning">
                            <div class="learningText">添加工作经历</div>
                            <!-- 填写工作经历 -->
                            <el-popover placement="bottom-start" width="350" trigger="click" v-model="experienceShow">
                                <el-form :model="workFrom" size="small" label-position="top" class="filter-form">
                                    <el-form-item label="工作日期">
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <el-date-picker v-model="workFrom.WorkStartDate" type="date"
                                                                value-format="yyyy-MM-dd"
                                                                placeholder="开始日期" class="w100"/>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-date-picker v-model="workFrom.WorkEndDate" type="date"
                                                                value-format="yyyy-MM-dd"
                                                                placeholder="结束日期" class="w100"/>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                    <el-form-item label="工作单位">
                                        <el-input v-model="workFrom.WorkUnit" placeholder="请输入工作单位" clearable
                                                  class="w100"/>
                                    </el-form-item>
                                    <el-form-item label="职称">
                                        <el-input v-model="workFrom.ProfessionalTitle" placeholder="请输入职称" clearable
                                                  class="w100"/>
                                    </el-form-item>
                                    <el-form-item label="职务">
                                        <el-input v-model="workFrom.Post" placeholder="请输入职务" clearable class="w100"/>
                                    </el-form-item>
                                    <el-form-item label="主要从事工作">
                                        <el-input v-model="workFrom.WorkName" placeholder="请输入主要从事工作" clearable
                                                  class="w100" size="small"/>
                                    </el-form-item>
                                </el-form>
                                <span class="dialog-footer">
                                    <div class="text-right mt18">
                                        <el-button size="mini" type="primary" plain @click="experienceShow = false"
                                                   class="mr8">
                                            取 消
                                        </el-button>
                                        <el-button type="primary" size="mini" @click="submitWorkForm">
                                            保 存
                                        </el-button>
                                    </div>
                                </span>
                                <el-button type="text" slot="reference">
                                    <i class="el-icon-circle-plus-outline iconAdd"/>
                                </el-button>
                            </el-popover>
                        </div>
                        <div class="timeBox" v-if="WorkList.length">
                            <el-timeline>
                                <el-timeline-item placement="top" v-for="(item,i) in workRange" :key="i"
                                                  color="#409EFF">
                                    <div class="iconDel" @click="workDel(i)">
                                        <i class="el-icon-delete"></i>
                                    </div>
                                    <div class="timelineItem"><span>工作时间：</span>{{ item.WorkStartDate }} 至 {{
                                        item.WorkEndDate }}
                                    </div>
                                    <div class="timelineItem"><span>工作单位：</span>{{ item.WorkUnit }}</div>
                                    <div class="timelineItem"><span>职称：</span>{{ item.ProfessionalTitle }}</div>
                                    <div class="timelineItem"><span>职务：</span>{{ item.Post }}</div>
                                    <div class="timelineItem"><span>主要从事工作：</span>{{ item.WorkName }}</div>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </el-form-item>
                    <el-form-item label="家庭成员" required>
                        <div class="iconLearning">
                            <div class="learningText">添加家庭成员</div>
                            <!-- 填写家庭成员 -->
                            <el-popover placement="bottom-start" width="350" trigger="click" v-model="MemberFamilyShow">
                                <div class="sketchAuto">
                                    <el-form :model="MemberFamilyForm" size="small" label-position="top"
                                             class="filter-form">
                                        <el-form-item label="姓名">
                                            <el-input v-model="MemberFamilyForm.UserName" placeholder="请输入姓名"
                                                      clearable/>
                                        </el-form-item>
                                        <el-form-item label="与本人关系">
                                            <el-input v-model="MemberFamilyForm.Relationship" placeholder="请输入与本人关系"
                                                      clearable/>
                                        </el-form-item>
                                        <el-form-item label="工作单位">
                                            <el-input v-model="MemberFamilyForm.WorkUnit" placeholder="请输入工作单位"
                                                      clearable/>
                                        </el-form-item>
                                        <el-form-item label="职务">
                                            <el-input v-model="MemberFamilyForm.Post" placeholder="请输入职务" clearable/>
                                        </el-form-item>
                                        <el-form-item label="户籍所在地">
                                            <el-input v-model="MemberFamilyForm.PlaceDomicile" placeholder="请输入户籍所在地"
                                                      clearable/>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <span class="dialog-footer">
                                    <div class="text-right mt18">
                                        <el-button type="primary" @click="submitMemberFamily" size="mini">
                                            保 存
                                        </el-button>
                                        <el-button @click="MemberFamilyShow = false" size="mini" type="primary" plain>
                                            取 消
                                        </el-button>
                                    </div>
                                </span>
                                <el-button type="text" slot="reference">
                                    <i class="el-icon-circle-plus-outline iconAdd"/>
                                </el-button>
                            </el-popover>
                        </div>
                        <div class="timeBox" v-if="MemberFamilyList.length">
                            <el-timeline>
                                <el-timeline-item placement="top" v-for="(item,i) in MemberFamilyList" :key="i"
                                                  color="#409EFF">
                                    <div class="iconDel" @click="MemberFamilyDel(i)">
                                        <i class="el-icon-delete"></i>
                                    </div>
                                    <div class="timelineItem"><span>姓名：</span>{{ item.UserName }}</div>
                                    <div class="timelineItem"><span>与本人关系：</span>{{ item.Relationship }}</div>
                                    <div class="timelineItem"><span>工作单位：</span>{{ item.WorkUnit }}</div>
                                    <div class="timelineItem"><span>职务：</span>{{ item.Post }}</div>
                                    <div class="timelineItem"><span>户籍所在地：</span>{{ item.PlaceDomicile }}</div>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </el-form-item>
                    <el-form-item label="奖惩情况">
                        <el-input type="textarea" :rows="6" placeholder="请输入内容" maxlength="2000" show-word-limit
                                  v-model="form.HonorCertificates" resize="none"/>
                    </el-form-item>
                    <el-form-item label="个人特长及突出业绩">
                        <el-input type="textarea" :rows="6" placeholder="请输入内容" maxlength="2000" show-word-limit
                                  v-model="form.Characteristic" resize="none"/>
                    </el-form-item>
                    <el-form-item>
              <span slot="label">
                备注<span style="color: #f56c6c">（请填写符合岗位条件的补充说明事项）</span>
              </span>
                        <el-input type="textarea" :rows="6" maxlength="2000" show-word-limit placeholder="请输入内容"
                                  v-model="form.Remark" resize="none"/>
                    </el-form-item>
                    <el-form-item label="上传个人照片：" prop="OneselfPhotograph">
                        <el-upload accept='image/gif,image/jpeg,image/jpg,image/png' class="avatar-uploader" action="#"
                                   :show-file-list="false" :http-request='uploadOneselfPhotograph'>
                            <img v-if="form.OneselfPhotograph" class="avatar"
                                 :src="`${BaseURL}/Common/AttachUrl?channeltype=6&filename=${form.OneselfPhotograph}`"
                                 alt="">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item required>
              <span slot="label">
                <span style="font-weight: bold;margin-left: 6px;">个人简历</span>
              </span>
                        <el-upload ref="upload" style="display: inline-block"
                                   action="#"
                                   accept='.jpeg,.jpg,.png,.pdf'
                                   :file-list="fileResumeList"
                                   :http-request="uploadFile"
                                   :on-remove="handleFileRemove"
                                   :before-upload="checkFileType"
                                   :auto-upload="true"
                                   :limit="5">
                            <el-button slot="trigger" size="small" type="primary" plain>
                                上传简历
                            </el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item required>
              <span slot="label">
                <span style="font-weight: bold;">身份证</span>
              </span>
                        <div class="mb20">
                            <el-upload action="#" accept='.jpeg,.jpg,.png' :before-upload="checkFileTypeImage"
                                       :http-request='uploadJust' :show-file-list='false'>
                                <el-button slot="trigger" size="small" type="primary" plain>
                                    上传身份证正面
                                </el-button>
                            </el-upload>
                            <div class="upload-list" v-show="fileNameIDCardFront">
                                <div class="upload_list_item mt10">
                                    <div class="upload_list_item-name">
                                        <i class="el-icon-document iconPrefix"/>
                                        {{ fileNameIDCardFront }}
                                        <i class="el-icon-upload-success el-icon-circle-check iconSuffix"></i>
                                        <i class="el-icon-close iconSuffix" @click="iconSuffixDel()"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <el-upload action="#" accept='.jpeg,.jpg,.png' :before-upload="checkFileTypeImage"
                                       :http-request='uploadBack' :show-file-list='false'>
                                <el-button slot="trigger" size="small" type="primary" plain>
                                    上传身份证反面
                                </el-button>
                            </el-upload>
                            <div class="upload-list" v-show="fileNameIDCardRear">
                                <div class="upload_list_item mt10">
                                    <div class="upload_list_item-name">
                                        <i class="el-icon-document iconPrefix"/>
                                        {{ fileNameIDCardRear }}
                                        <i class="el-icon-upload-success el-icon-circle-check iconSuffix"></i>
                                        <i class="el-icon-close iconSuffix" @click="iconPrefixDel()"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
              <span slot="label">
                  <span style="font-weight: bold">各层次毕业证、学位证<span class="text-danger">（必须提供）</span></span>
                </span>
                        <div class="mb20">
                            <el-upload ref="upload" style="display: inline-block"
                                       action="#"
                                       accept='.jpeg,.jpg,.png'
                                       :file-list="DiplomaList"
                                       :http-request="diplomaProveUploadFile"
                                       :on-remove="diplomaProveUploadFileRemove"
                                       :before-upload="checkFileTypeImage"
                                       :auto-upload="true"
                                       :limit="5">
                                <el-button slot="trigger" size="small" type="primary" plain>
                                    上传毕业证
                                </el-button>
                            </el-upload>
                        </div>
                        <div>
                            <el-upload ref="upload" style="display: inline-block"
                                       action="#"
                                       accept='.jpeg,.jpg,.png'
                                       :file-list="DegreeCertificate"
                                       :http-request="educationDegreeProveUploadFile"
                                       :on-remove="fileDegreFileRemove"
                                       :before-upload="checkFileTypeImage"
                                       :auto-upload="true"
                                       :limit="5">
                                <el-button slot="trigger" size="small" type="primary" plain>
                                    上传学位证
                                </el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item>
              <span slot="label">
                <span style="font-weight: bold">学信网生成的各层次学历、学位认证报告<span class="text-danger">（必须提供）</span></span>
              </span>
                        <div class="mb20">
                            <el-upload ref="upload" style="display: inline-block"
                                       action="#"
                                       accept='.jpeg,.jpg,.png,.pdf'
                                       :file-list="DiplomaAuthentica"
                                       :http-request="DiplomaAuthenticaUploadFile"
                                       :on-remove="DiplomaAuthenticaFileRemove"
                                       :before-upload="checkFileType"
                                       :auto-upload="true"
                                       :limit="5">
                                <el-button slot="trigger" size="small" type="primary" plain>
                                    上传学历认证报告
                                </el-button>
                            </el-upload>
                        </div>
                        <div>
                            <el-upload ref="upload" style="display: inline-block"
                                       action="#"
                                       accept='.jpeg,.jpg,.png,.pdf'
                                       :file-list="DegreeCertificateAuthentica"
                                       :http-request="DegreeCertificationUploadFile"
                                       :on-remove="DegreeCertificationFileRemove"
                                       :before-upload="checkFileType"
                                       :auto-upload="true"
                                       :limit="5">
                                <el-button slot="trigger" size="small" type="primary" plain>
                                    上传学位认证报告
                                </el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item>
            <span slot="label">
                <span style="font-weight: bold">应届毕业生证明材料<span class="text-danger">（应届生必须提供）</span></span>
              </span>
                        <div class="mb20">
                            <el-upload ref="upload" style="display: inline-block"
                                       action="#"
                                       :file-list="StudentCertification"
                                       :http-request="studentStatusProveUploadFile"
                                       :on-remove="studentStatusProveFileRemove"
                                       :auto-upload="true"
                                       :limit="5">
                                <el-button slot="trigger" size="small" type="primary" plain>
                                    上传学籍认证报告
                                </el-button>
                            </el-upload>
                        </div>
                        <div>
                            <el-upload ref="upload" style="display: inline-block"
                                       action="#"
                                       :file-list="GetJobRecommend"
                                       :http-request="otherRelevantProveUploadFile"
                                       :on-remove="otherRelevantProveFileRemove"
                                       :auto-upload="true"
                                       :limit="5">
                                <el-button slot="trigger" size="small" type="primary" plain>
                                    上传就业推荐表、学校成绩单、学生证等其他相关证明材料
                                </el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item>
              <span slot="label">
                <span style="font-weight: bold">工作证明<span class="text-danger">（有工作经历者必须提供工作证明）</span></span>
              </span>
                        <el-upload ref="upload" style="display: inline-block"
                                   action="#"
                                   :file-list="WorkProve"
                                   :http-request="WorkProveUploadFile"
                                   :on-remove="WorkProveFileRemove"
                                   :auto-upload="true"
                                   :limit="5">
                            <el-button slot="trigger" size="small" type="primary" plain>
                                上传工作证明
                            </el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
              <span slot="label">
                <span style="font-weight: bold">各级专业技术资格证书</span>
              </span>
                        <el-upload ref="upload" style="display: inline-block"
                                   action="#"
                                   :file-list="QualificationCertificate"
                                   :http-request="QualificationCertificateUploadFile"
                                   :on-remove="QualificationCertificateFileRemove"
                                   :auto-upload="true"
                                   :limit="5">
                            <el-button slot="trigger" size="small" type="primary" plain>
                                上传各级专业技术资格证书
                            </el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
              <span slot="label">
                <span style="font-weight: bold">获奖证书及其他有关证书</span>
              </span>
                        <el-upload ref="upload" style="display: inline-block"
                                   action="#"
                                   :file-list="fileList"
                                   :http-request="RestsCertificateUploadFile"
                                   :on-remove="fileRestscertificateListRemove"
                                   :auto-upload="true"
                                   :limit="5">
                            <el-button slot="trigger" size="small" type="primary" plain>
                                上传获奖证书及其他有关证书
                            </el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div class="footSocial mt20">
                    <el-button type="primary" size="mini" @click="handleSubmit('form')">
                        提 交
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {validateSfz, verifyPhone, verifyMailbox} from "@/utils/index"
    // import 'lib-flexible/flexible'

    export default {
        data() {
            // 手机号码
            const checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入联系方式'))
                } else if (!verifyPhone(value)) {
                    callback(new Error('您输入的手机号码格式不正确'))
                } else {
                    callback()
                }
            }

            // 邮箱
            const emailValue = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入邮箱'))
                } else if (!verifyMailbox(value)) {
                    callback(new Error('您输入的邮箱格式不正确'))
                } else {
                    callback()
                }
            }

            return {
                token: "",
                deliveryID: '',    // 岗位投递选择
                positionID: '',   // 科室
                mingeID: '',   // 学历
                posttitleNav: [],  // 获取岗位下拉
                getDepartNav: [],   // 获取部门下拉
                pullByDepartNav: [],  // 学历
                fileList: [],
                fileResumeList: [],   // 个人简历
                DiplomaList: [],     // 毕业证
                DegreeCertificate: [],   // 学位证明
                DiplomaAuthentica: [],  // 毕业认证
                DegreeCertificateAuthentica: [],    // 学位证明
                StudentCertification: [],   // 学籍认证报告
                GetJobRecommend: [],  //  就业推荐表、学校成绩单、学生证等其他相关证明材料
                WorkProve: [],   // 工作证明
                QualificationCertificate: [],  // 资格证书
                RestsCertificate: [],   // 获奖证书及其他有关证书

                fileNameIDCardFront: '',   // 身份证正面文件名
                fileNameIDCardRear: '',  // 身份证反面文件名
                progress: 0,
                fileName: "",
                disabled: false,
                educationShow: false,  // 学习经历
                experienceShow: false,  //  工作经历
                MemberFamilyShow: false,  // 家庭成员
                NatureUnitNav: [],   // 单位性质
                HighestNav: [],
                // 学习形式
                learningNav: [],
                politicsNav: [], // 政治面貌
                englishNav: [],    // 英语水平等级
                computerNav: [],  // 计算机水平等级
                titleTypeNav: [],   // 职称下拉
                degreeNav: [],   // 学位下拉
                StudyList: [],  // 学习经历
                WorkList: [],  // 工作经历
                MemberFamilyList: [],  // 家庭成员
                educationVlue: '',  // 学历ID
                EducationID: '',  // 请选择学历ID
                EducationStyle: '',   // 请选择学历
                BaseURL: 'http://zjeyapi2.ypaiban.com/api',
                form: {
                    PlanID: '',
                    UserName: '',   // 姓名
                    OneselfPhotograph: '',  // 个人证件
                    BirthDate: '',  // 出生年月日
                    Sex: '',   // 性别 （0 男 1 女）
                    Nation: '',   // 民族
                    NativePlace: '',   // 籍贯
                    PoliticsStatus: '',  // 政治面貌
                    PlaceDomicile: '',    // 现户籍地
                    MaritalStatus: '',   // 婚姻状况 0未婚 1 已婚 2离异 3 丧偶
                    IDCardNumber: '',   // 身份证号码
                    ContactWay: '',   // 联系方式
                    Email: '',  // 电子邮箱
                    MailingAddress: '',  // 通讯地址
                    ZipCode: '',    // 邮编
                    HighestEducationID: '',   // 最高学历ID
                    HighestEducation: '',    // 最高学历
                    GraduationDate: '', // 毕业时间
                    GraduateSchool: '',  // 毕业学校
                    Major: '',   // 专业
                    Post: '',  // 职称
                    ProfessionalSkill: '',  // 专业技术资格
                    Height: '',   // 身高
                    DegreeID: '', // 学位ID
                    Degree: '', // 学位
                    EnglishLevelID: '', // 英语水平ID
                    EnglishLevel: '',  // 英语水平等级
                    ComputerLevel: '', // 计算机水平等级
                    LastCompany: '',   // 工作单位（实习/规培）
                    NatureUnit: '',  // 单位性质(0=企业;1=事业单位、2=国家行政机关;3=政府)
                    NatureUnitID: '',  // 单位性质ID
                    LearningStyleID: '',   // 学习形式ID
                    LearningStyle: '',   // 学习形式
                    PracticeCertificate: '',  // 执业资格
                    worktime: '',  // 参加工作时间
                    IDCardRear: '',  // 身份证反面
                    IDCardFront: '',  // 身份证正面
                },
                rules: {
                    UserName: [{required: true, trigger: "blur", message: "请输入姓名"}],
                    Sex: [{required: true, trigger: "change", message: "请输入性别"}],
                    BirthDate: [{required: true, trigger: "change", message: "请选择出生日期"}],
                    ContactWay: [{required: true, validator: checkPhone, trigger: 'blur'}],
                    Email: [{required: true, validator: emailValue, trigger: "blur"}],
                    HighestEducationID: [{required: true, trigger: "change", message: "请选择最高学历"}],
                    GraduateSchool: [{required: true, trigger: "blur", message: "请输入毕业学校"}],
                    LearningStyleID: [{required: true, trigger: "change", message: "请选择学习形式"}],
                    IDCardNumber: [{required: true, validator: validateSfz, trigger: 'blur'}],
                    DegreeID: [{required: true, trigger: "change", message: "请选择学位"}],
                    NativePlace: [{required: true, trigger: "blur", message: "请输入籍贯"}],
                    GraduationDate: [{required: true, trigger: "change", message: "请选择毕业时间"}],
                    Major: [{required: true, trigger: "blur", message: "请输入所学专业"}],
                    PoliticsStatus: [{required: true, trigger: "change", message: "请选择政治面貌"}],
                    MaritalStatus: [{required: true, trigger: "change", message: "请选择婚姻状况"}],
                    PlaceDomicile: [{required: true, trigger: "blur", message: "请输入现户籍地（例：广东省湛江市霞山区）"}],
                    Nation: [{required: true, trigger: "blur", message: "请输入民族"}],
                    EnglishLevelID: [{required: true, trigger: "change", message: "请选择英语水平等级"}],
                    OneselfPhotograph: [{required: true, trigger: "change", message: "请上传个人照片"}],
                    ComputerLevel: [{required: true, trigger: "blur", message: "请输入计算机水平等级"}],
                    Height: [{required: true, trigger: "blur", message: "请输入身高（单位cm）"}],
                    ProfessionalSkill: [{required: true, trigger: "blur", message: "请输入最高专业技术资格"}],
                    MailingAddress: [{required: true, trigger: "blur", message: "请输入详细通讯地址（精确到街道、单位或小区）"}],
                },

                // 学习经历
                EducationNav: [],  // 学习经历 - 学历
                studyForm: {
                    StudyStartDate: '',   // 学习开始时间
                    StudyEndDate: '',     // 学习结束时间
                    EducationID: '',      // 学历ID
                    GraduationSchool: '',   // 毕业学校
                    EducationalSystem: '',    // 学制
                    Major: '',    // 所学专业
                    LearningStyleID: '',   // 学习形式ID
                },

                // 工作经历
                workFrom: {
                    WorkStartDate: '',   // 工作开始日期
                    WorkEndDate: '',    // 工作结束日期
                    WorkUnit: '',    // 工作单位
                    ProfessionalTitle: '',   // 职称
                    Post: '',        // 职务
                    WorkName: ''    // 主要从事工作
                },

                // 家庭成员
                MemberFamilyForm: {
                    UserName: '',   // 姓名
                    Relationship: '',   // 与本人关系
                    WorkUnit: '',    // 工作单位
                    Post: '',    // 职称
                    PlaceDomicile: '',   // 户籍所在地
                },

                // 家庭成员表单校验
                MemberFamilyRules: [
                    {
                        message: '请输入姓名',
                        key: 'UserName'
                    },
                    {
                        message: '请输入与本人关系',
                        key: 'Relationship'
                    },
                    {
                        message: '请输入工作单位',
                        key: 'WorkUnit'
                    },
                    {
                        message: '请输入职务',
                        key: 'Post'
                    },
                    {
                        message: '请输入户籍所在地',
                        key: 'PlaceDomicile'
                    },
                ],

                // 学习经历表单校验
                educationRules: [
                    {
                        message: '请选择学习开始时间',
                        key: 'StudyStartDate'
                    },
                    {
                        message: '请选择学习结束时间',
                        key: 'StudyEndDate'
                    },
                    {
                        message: '请输入毕业院校',
                        key: 'GraduationSchool'
                    },
                    {
                        message: '请选择学历',
                        key: 'EducationID'
                    },
                    {
                        message: '请选择学习形式',
                        key: 'LearningStyleID'
                    },
                    {
                        message: '请输入学制',
                        key: 'EducationalSystem'
                    },
                    {
                        message: '请输入所学专业',
                        key: 'Major'
                    },
                ],

                workRules: [
                    {
                        message: '请输入工作开始时间',
                        key: 'WorkStartDate'
                    },
                    {
                        message: '请输入工作结束时间',
                        key: 'WorkEndDate'
                    },
                    {
                        message: '请输入工作单位',
                        key: 'WorkUnit'
                    },
                    {
                        message: '请输入职称',
                        key: 'ProfessionalTitle'
                    },
                    {
                        message: '请输入职务',
                        key: 'Post'
                    },
                    {
                        message: '请输入主要从事工作',
                        key: 'WorkName'
                    },
                ]
            }
        },
        created() {
            this.token = sessionStorage.getItem("token")
            this.getHighestNav()
            this.getPoliticsNav()   // 政治面貌
            this.getDegreeNav()  // 学位
            this.getEnglishNav()   // 英语水平等级
            this.getLearningNav()    // 学习形式
            this.getNatureUnitNav()   // 单位性质
            this.getEducationNav()
            this.getPosttitleNav()
        },
        computed: {
            // 学习经历
            range() {
                return this.StudyList.slice().sort((a, b) => new Date(a.StudyStartDate).getTime() - new Date(b.StudyStartDate).getTime()); //结合reverse(),成功实现降序排列
            },

            // 工作经历
            workRange() {
                return this.WorkList.slice().sort((a, b) => new Date(a.WorkStartDate).getTime() - new Date(b.WorkEndDate).getTime()); //结合reverse(),成功实现降序排列
            },
        },
        methods: {
            // 获取岗位下拉（微信）
            getPosttitleNav() {
                this.myFetch.get("/RecruitManagement/GetPostPullWX").then(res => {
                    this.posttitleNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 招聘岗位
            changePosition(val) {
                let obj = {}
                obj = this.posttitleNav.find(item => {
                    return item.posttitle === val
                })

                this.dropTitle = obj.posttitle
                this.droptionname = obj.positionname
                this.getDepartListPullByPostWX(obj.posttitle, obj.positionname)
                this.getDepartNav = []  // 部门
                this.pullByDepartNav = []   // 学历
            },

            // 请选择科室/部门
            changePositionNav(val) {
                this.mingeName = val
                this.mingeID = ""   // 学历
                this.GetPullByDepartWX(this.dropTitle, this.droptionname, this.mingeName)
            },

            // 获取部门下拉
            getDepartListPullByPostWX(posttitle, positionname) {
                this.myFetch.get(`/RecruitManagement/GetDepartListPullByPostWX?PostTitle=${posttitle}&PositionName=${positionname}`).then(res => {
                    this.getDepartNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 获取学历下拉
            GetPullByDepartWX(posttitle, positionname, mingeName) {
                this.myFetch.get(`/RecruitManagement/GetEducationNameListPullByDepartWX?PostTitle=${posttitle}&PositionName=${positionname}&DepartName=${mingeName}`).then(res => {
                    this.pullByDepartNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 上传个人照片
            async uploadOneselfPhotograph({file}) {
                const fileObj = new FormData();
                fileObj.append("files", file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.form.OneselfPhotograph = res.data.data[0].filename
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 个人简历
            async uploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.fileResumeList.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 个人简历删除
            handleFileRemove(file, fileList) {
                this.fileResumeList = fileList
            },


            // 上传身份证正面
            async uploadJust(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.fileNameIDCardFront = res.data.data[0].originalfilename
                    this.form.IDCardFront = res.data.data[0].filename
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    })
                })
            },

            // 上传身份证反面
            async uploadBack(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.fileNameIDCardRear = res.data.data[0].originalfilename
                    this.form.IDCardRear = res.data.data[0].filename
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    })
                })
            },

            // 毕业证
            async diplomaProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.DiplomaList.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 毕业证删除
            diplomaProveUploadFileRemove(file, fileList) {
                this.DiplomaList = fileList
            },

            // 学位证明
            async educationDegreeProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.DegreeCertificate.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除学位证明
            fileDegreFileRemove(file, fileList) {
                this.DegreeCertificate = fileList
            },

            // 毕业认证
            async DiplomaAuthenticaUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.DiplomaAuthentica.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    })
                })
            },

            // 删除毕业认证
            DiplomaAuthenticaFileRemove(file, fileList) {
                this.DiplomaAuthentica = fileList
            },

            // 学位证明
            async DegreeCertificationUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.DegreeCertificateAuthentica.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    })
                })
            },

            // 删除学位证明
            DegreeCertificationFileRemove(file, fileList) {
                this.DegreeCertificateAuthentica = fileList
            },

            // 学籍认证报告
            async studentStatusProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.StudentCertification.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },


            // 删除学籍认证报告
            studentStatusProveFileRemove(file, fileList) {
                this.StudentCertification = fileList
            },

            // 就业推荐表、学校成绩单、学生证等其他相关证明材料
            async otherRelevantProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file)
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.GetJobRecommend.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 证明材料
            otherRelevantProveFileRemove(file, fileList) {
                this.GetJobRecommend = fileList
            },

            // 工作证明
            async WorkProveUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.WorkProve.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    })
                })
            },

            // 删除工作证明
            WorkProveFileRemove(file, fileList) {
                this.WorkProve = fileList
            },

            // 资格证书
            async QualificationCertificateUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.QualificationCertificate.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除资格证书
            QualificationCertificateFileRemove(file, fileList) {
                this.QualificationCertificate = fileList
            },

            // 其他有关证书
            async RestsCertificateUploadFile(param) {
                const fileObj = new FormData();
                fileObj.append("files", param.file);
                this.myFetch.post("/RecruitTalentPool/WXUploadAttachFile?channeltype=6", fileObj).then(res => {
                    this.RestsCertificate.push(
                        {
                            name: res.data.data[0].originalfilename,
                            url: res.data.data[0].filename
                        }
                    )
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 删除其他有关证书
            fileRestscertificateListRemove(file, fileList) {
                this.RestsCertificate = fileList
            },

            // 请选择最高学历
            changeHighest(val) {
                let obj = {}
                obj = this.HighestNav.find(item => {
                    return item.dict_code === val
                })
                this.form.HighestEducationID = obj.dict_code
                this.form.HighestEducation = obj.dict_label
            },

            // 学位
            changeDegree(val) {
                let obj = {}
                obj = this.degreeNav.find(item => {
                    return item.dict_code === val
                })
                this.form.DegreeID = obj.dict_code
                this.form.Degree = obj.dict_label
            },

            // 学习形式
            changeLearning(val) {
                let obj = {}
                obj = this.learningNav.find(item => {
                    return item.dict_code === val
                })
                this.form.LearningStyleID = obj.dict_code
                this.form.LearningStyle = obj.dict_label
            },

            // 请选择学历
            changeEducation(val) {
                let obj = {}
                obj = this.EducationNav.find(item => {
                    return item.dict_code === val
                })
                this.EducationID = obj.dict_code
                this.EducationStyle = obj.dict_label
            },

            // 英语水平等级
            changeEnglish(val) {
                let obj = {}
                obj = this.englishNav.find(item => {
                    return item.dict_code === val
                })
                this.form.EnglishLevelID = obj.dict_code
                this.form.EnglishLevel = obj.dict_label
            },

            // 单位性质
            changeNatureUnit(val) {
                let obj = {}
                obj = this.NatureUnitNav.find(item => {
                    return item.dict_code === val
                })
                this.form.NatureUnitID = obj.dict_code
                this.form.NatureUnit = obj.dict_label
            },

            // 最高学历
            getEducationNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'recruit_education'}).then(res => {
                    this.EducationNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 单位性质
            getNatureUnitNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'Unit_Properties'}).then(res => {
                    this.NatureUnitNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 职称
            changePost(val) {
                let obj = {}
                obj = this.titleTypeNav.find(item => {
                    return item.dict_code === val
                })
                this.form.PostID = obj.dict_code
                this.form.Post = obj.dict_label
            },

            // 获取最高学历
            getHighestNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'education'}).then(res => {
                    this.HighestNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 政治面貌
            getPoliticsNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'political_outlook'}).then(res => {
                    this.politicsNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 学习形式
            getLearningNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'Learning_form'}).then(res => {
                    this.learningNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 英语水平等级
            getEnglishNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'sys_english_level'}).then(res => {
                    this.englishNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 学位
            getDegreeNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'academic_degree'}).then(res => {
                    this.degreeNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    })
                })
            },

            // 学习经历删除
            studyDel(i) {
                this.StudyList.splice(i, 1);
            },

            // 家庭成员
            MemberFamilyDel(i) {
                this.MemberFamilyList.splice(i, 1);
            },

            // 工作经历删除
            workDel(i) {
                this.WorkList.splice(i, 1);
            },

            // 上传学习经历弹窗
            submitForm() {
                for (let key in this.studyForm) {
                    for (let i = 0; i < this.educationRules.length; i++) {
                        if (!this.studyForm[key] && key == this.educationRules[i].key) {
                            return this.$message.warning(this.educationRules[i].message)
                        }
                    }
                }
                this.StudyList.push({
                    StudyStartDate: this.studyForm.StudyStartDate,  // 学习开始时间
                    StudyEndDate: this.studyForm.StudyEndDate,   // 学习结束时间
                    EducationID: this.EducationID,  // 学历
                    EducationStyle: this.EducationStyle,  // 学历
                    GraduationSchool: this.studyForm.GraduationSchool,  // 毕业院校
                    EducationalSystem: this.studyForm.EducationalSystem,   // 学制
                    Major: this.studyForm.Major,    // 所学专业
                    LearningStyleID: this.form.LearningStyleID,   // 学习形式
                    LearningStyle: this.form.LearningStyle   // 学习形式
                })

                this.educationShow = false
                for (let key in this.studyForm) {
                    this.studyForm[key] = ''
                }
            },

            // 工作经历提交
            submitWorkForm() {
                for (let key in this.workFrom) {
                    for (let i = 0; i < this.workRules.length; i++) {
                        if (!this.workFrom[key] && key == this.workRules[i].key) {
                            return this.$message.warning(this.workRules[i].message)
                        }
                    }
                }

                this.WorkList.push({
                    WorkStartDate: this.workFrom.WorkStartDate,  // 工作开始时间
                    WorkEndDate: this.workFrom.WorkEndDate,   // 工作结束时间
                    WorkUnit: this.workFrom.WorkUnit,   // 工作单位
                    ProfessionalTitle: this.workFrom.ProfessionalTitle,  // 职称
                    Post: this.workFrom.Post,  // 职务
                    WorkName: this.workFrom.WorkName,  // 主要从事工作
                })

                this.experienceShow = false
                for (let key in this.workFrom) {
                    this.workFrom[key] = ''
                }
            },

            // 家庭成员
            submitMemberFamily() {
                for (let key in this.MemberFamilyForm) {
                    for (let i = 0; i < this.MemberFamilyRules.length; i++) {
                        if (!this.MemberFamilyForm[key] && key == this.MemberFamilyRules[i].key) {
                            return this.$message.warning(this.MemberFamilyRules[i].message)
                        }
                    }
                }
                this.MemberFamilyList.push({
                    UserName: this.MemberFamilyForm.UserName,     // 姓名
                    Relationship: this.MemberFamilyForm.Relationship,    // 与本人关系
                    WorkUnit: this.MemberFamilyForm.WorkUnit,    // 工作单位
                    Post: this.MemberFamilyForm.Post,   // 职务
                    PlaceDomicile: this.MemberFamilyForm.PlaceDomicile,   // 户籍所在地
                })

                this.MemberFamilyShow = false
                for (let key in this.MemberFamilyForm) {
                    this.MemberFamilyForm[key] = ''
                }
            },

            // 上传学历经历弹窗
            handleClose() {
                this.educationShow = false
                for (let key in this.studyForm) {
                    this.studyForm[key] = ''
                }
            },

            // 处理form提交参数
            formatFormParams() {
                let params = {}

                // 学习经历
                let studyArray = this.StudyList.map(item => {
                    return {
                        StudyStartDate: item.StudyStartDate,   // 学习开始时间
                        StudyEndDate: item.StudyEndDate, // 学习结束时间
                        EducationID: item.EducationID,    // 学历ID
                        GraduationSchool: item.GraduationSchool,   // 毕业学校
                        EducationalSystem: item.EducationalSystem,   // 学制
                        Major: item.Major,      // 所学专业
                        LearningStyleID: item.LearningStyleID   // 学习形式
                    }
                })

                params = {
                    ...this.form,
                    PlanID: this.mingeID,
                    OpenID: "",
                    PersonageTitle: '',
                    ResumeState: 0,
                    RecruitType: 0,   // 0 社招 1 校园招聘
                    StudyList: studyArray,   // 学习经历
                    WorkList: this.WorkList,   // 工作经历
                    MemberFamilyList: this.MemberFamilyList,   // 家庭成员
                    OneselfPhotograph: this.form.OneselfPhotograph,  // 个人证件照
                    Diploma: this.DiplomaList.map(item => item.url).join(),  // 毕业证
                    DegreeCertificate: this.DegreeCertificate.map(item => item.url).join(),  // 学位证
                    Resume: this.fileResumeList.map(item => item.url).join(),   // 个人简历
                    GetJobRecommend: this.GetJobRecommend.map(item => item.url).join(),  // 就业推荐,学校成绩单,学生证
                    DiplomaAuthentica: this.DiplomaAuthentica.map(item => item.url).join(),   // 学历认证
                    DegreeCertificateAuthentica: this.DegreeCertificateAuthentica.map(item => item.url).join(),  // 学位认证
                    StudentCertification: this.StudentCertification.map(item => item.url).join(),  // 学籍认证报告
                    WorkProve: this.WorkProve.map(item => item.url).join(),   // 工作证明
                    QualificationCertificate: this.QualificationCertificate.map(item => item.url).join(),   // 资格证书
                    RestsCertificate: this.RestsCertificate.map(item => item.url).join(),   // 获奖证书及其他有关证书
                }
                return params
            },

            // 提交按钮禁用3s
            countDown() {
                const TIME_COUNT = 3
                if (!this.timer) {
                    this.count = TIME_COUNT
                    this.timer = setInterval(() => {
                        if (this.count > 1 && this.count <= TIME_COUNT) { //限制倒计时区间
                            this.count--
                        } else {
                            clearInterval(this.timer)   //删除定时器
                            this.timer = null
                            location.reload()
                        }
                    }, 1000)
                }
            },

            // 保存
            handleSubmit(formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        if (this.StudyList.length == 0) {
                            return this.$message.warning('请添加学习经历')
                        }

                        if (this.MemberFamilyList.length == 0) {
                            return this.$message.warning('请添加家庭成员')
                        }

                        // 个人简历
                        if (this.fileResumeList.length == 0) {
                            return this.$message.warning('请上传个人简历')
                        } else if (!this.form.IDCardFront) {  // 身份证正面
                            return this.$message.warning('请上传身份证正面')
                        } else if (!this.form.IDCardRear) {   // 身份证反面
                            return this.$message.warning('请上传身份证反面')
                        }

                        let params = this.formatFormParams()
                        this.$confirm('<div style="text-indent: 22px;line-height: 23px;font-size: 15px;color: #ee0a24;">本人网上提交的资料和照片，必须和提交的纸质版复印件一致，如有不一致，一切后果由本人承担, 是否确认提交?</div>', '提醒注意', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            showClose: false,
                            dangerouslyUseHTMLString: true,
                            customClass: 'newsClass',
                            closeOnClickModal: false,
                        }).then(() => {
                            this.myFetch.post("/RecruitManagement/CreateResumeWX", params).then(res => {
                                if (res.data.code == 0) {
                                    this.$message.success(`已申请成功！`);
                                    this.countDown()
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                this.$message({
                                    message: "网络或程序异常！" + e,
                                    type: "error"
                                });
                            })
                        }).catch(() => {
                        })
                    } else {
                        this.$message.warning('请正确完善所有信息')
                        return false
                    }
                })
            },

            // 删除正面身份证
            iconSuffixDel() {
                this.fileNameIDCardFront = ""
                this.form.IDCardFront = ''
            },

            // 删除反面身份证
            iconPrefixDel() {
                this.fileNameIDCardRear = ""
                this.form.IDCardRear = ''
            },

            // 文件类型图片跟pdf判断
            checkFileType(file) {
                const fileType = file.type;
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
                if (!allowedTypes.includes(fileType)) {
                    this.$message.error('只能上传图片跟pdf文件');
                    return false;
                }
                return true;
            },

            // 只能上传图片
            checkFileTypeImage(file) {
                const fileType = file.type;
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
                if (!allowedTypes.includes(fileType)) {
                    this.$message.error('只能上传图片');
                    return false;
                }
                return true;
            }
        }
    };
</script>

<style scoped lang="scss">
    @import "socialcss";
</style>
